import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private snackBar = inject(MatSnackBar);

    success(message: string) {
        this.showMessage('notification-success', message);
    }

    failure(message: string) {
        this.showMessage('notification-failure', message);
    }

    private showMessage(panelClass: string, message: string) {
        this.snackBar.open(message, undefined, {
            panelClass: panelClass,
            duration: 3000,
            verticalPosition: 'top',
        });
    }
}
